import { render, staticRenderFns } from "./ViewNotes.vue?vue&type=template&id=8fb5e310&scoped=true&"
import script from "./ViewNotes.vue?vue&type=script&lang=js&"
export * from "./ViewNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb5e310",
  null
  
)

export default component.exports